import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { enableProdMode, isDevMode } from "@angular/core";
import * as Sentry from "@sentry/angular";
// Initialize PostHog with defensive typing
declare const posthog: any;

// Dynamic import to avoid TypeScript issues
async function initializePostHog() {
  // Only initialize PostHog if enabled in environment
  if (!environment.posthog?.enabled) {
    console.log('PostHog disabled in this environment');
    return;
  }

  try {
    const { default: posthog } = await import('posthog-js');
    posthog.init(
      environment.posthog.key,
      {
        api_host: environment.posthog.host,
        person_profiles: 'always', // or 'always' to create profiles for anonymous users as well
      }
    );
    console.log('PostHog initialized successfully');
  } catch (error) {
    console.warn('PostHog initialization failed:', error);
  }
}

// Initialize PostHog
initializePostHog();

if (!isDevMode()) {
  enableProdMode();

  Sentry.init({
    dsn: "https://663819ed2e904b2426dddfc7a70932ac@o4507919649603584.ingest.us.sentry.io/4507919651962880",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    environment: environment.environment,
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [environment.baseUrl],
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });
}


platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
